import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import style from "./style.scss";
import cn from "classnames";

export default ({ open, links }) => {
  let activeClassName = cn(style.active);

  useEffect(() => {
    const e = document.getElementById("side");
    if (open) setTimeout(() => e.focus(), 720);
  }, [open]);

  return (
    <div className={cn(style.sidebar, open ? style.slideIn : style.slideOut)}>
      <a href={"#"} id={"side"} className={cn(style.side)} />
      {links.map(({ label, to }, i) => (
        <div key={i} className={cn(style.link)}>
          <NavLink
            to={to}
            end={to == "/" ? true : ""}
            className={({ isActive }) =>
              isActive ? activeClassName : undefined
            }
          >
            {label}
          </NavLink>
        </div>
      ))}
    </div>
  );
};
